import React from 'react';
import Loading from '@gp/components/Loading';
import PageAccess from '@gp/components/PageAccess';
import useDPSReportsPermission from '../../_hooks/useDPSReportsPermission';
import { DESCRIPTION_B } from '@gp/constants/noPermissionTips';

import type { IBaseProps } from '@home/types/common';

interface IReportPermissionCheckerProps extends Omit<IBaseProps, 'children'> {
  mode: 'view' | 'edit';
  children: React.ReactElement;
}

const ReportPermissionChecker: React.FC<IReportPermissionCheckerProps> = (props) => {
  const { mode, children } = props;

  const { isLoading, hasViewPermission, hasEditPermission, ...restParams } = useDPSReportsPermission();
  const isAccess = mode === 'edit' ? hasEditPermission : hasViewPermission;

  if (isLoading) return <Loading loading />;

  return (
    <PageAccess isAccess={isAccess} description={DESCRIPTION_B}>
      {React.cloneElement(children, { isLoading, hasViewPermission, hasEditPermission, ...restParams })}
    </PageAccess>
  );
};

export default ReportPermissionChecker;
